export const getModalFocusableElements = (
    modal
) => {
    const selector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'textarea:not([disabled])',
        'select:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    return Array.from(
        modal.querySelectorAll(
            selector
        )
    ).filter((element) => {
        return (
            element
                instanceof HTMLElement
            && !element.hidden
            && !element.closest(
                '[hidden]'
            )
            && !element.classList
                .contains('hidden')
        );
    });
};

export const trapModalFocus = (
    event,
    modal
) => {
    if (event.key !== 'Tab') {
        return false;
    }

    const focusableElements =
        getModalFocusableElements(
            modal
        );

    if (
        focusableElements.length === 0
    ) {
        event.preventDefault();

        modal.focus();

        return true;
    }

    const firstElement =
        focusableElements[0];

    const lastElement =
        focusableElements[
            focusableElements.length - 1
        ];

    const activeElement =
        document.activeElement;

    if (
        event.shiftKey
        && (
            activeElement
                === firstElement
            || !modal.contains(
                activeElement
            )
        )
    ) {
        event.preventDefault();

        lastElement.focus();

        return true;
    }

    if (
        !event.shiftKey
        && activeElement
            === lastElement
    ) {
        event.preventDefault();

        firstElement.focus();

        return true;
    }

    return false;
};